// extracted by mini-css-extract-plugin
module.exports = {"aboutUs":"aboutUs_aboutUs__1YRq-"};